// PendingApprovalBanner.tsx
// Shows a prominent banner for users awaiting admin approval (previously deleted users)

import React from 'react';
import { Alert, Typography, Box } from '@mui/joy';
import InfoIcon from '@mui/icons-material/Info';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

interface Props {
  userEmail?: string;
}

export default function PendingApprovalBanner({ userEmail }: Props) {
  return (
    <Box sx={{ 
      position: 'fixed',
      top: 70, // Below header
      left: 0,
      right: 0,
      zIndex: 9999,
      p: 2,
      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
      borderBottom: '2px solid #f59e0b',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
    }}>
      <Alert
        color="warning"
        variant="soft"
        startDecorator={<HourglassBottomIcon />}
        sx={{ 
          maxWidth: 1000,
          margin: '0 auto',
          background: 'transparent',
          border: 'none'
        }}
      >
        <Box>
          <Typography level="title-md" sx={{ mb: 0.5 }}>
            ⏳ Your Trial Request is Pending Admin Approval
          </Typography>
          <Typography level="body-sm" sx={{ opacity: 0.9 }}>
            You have successfully logged in, but your account requires administrator approval before you can create charts and use features. 
            This typically happens when an account was previously deleted.
          </Typography>
          <Typography level="body-sm" sx={{ mt: 1, fontWeight: 600 }}>
            <InfoIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'middle' }} />
            You will receive an email notification at <strong>{userEmail || 'your registered email'}</strong> once approved. 
            This usually takes 1-2 business days.
          </Typography>
          <Typography level="body-xs" sx={{ mt: 1, opacity: 0.7 }}>
            Need urgent access? Contact support at <a href="mailto:support@shreemastro.com" style={{ color: '#d97706', textDecoration: 'underline' }}>support@shreemastro.com</a>
          </Typography>
        </Box>
      </Alert>
    </Box>
  );
}
